import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import TransactionRow from 'modules/common/components/TransactionRow';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';
import BuildingOwnerModal from '../modals/BuildingOwnerModal';

function BuildingOwnersContent({
  handleEdit,
  handleRemove,
  buildingOwnerId,
  showData,
  dataInfo,
}) {

  useEffect(() => {
    if (_.isEmpty(buildingOwnerId)) return;
    showData(buildingOwnerId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(buildingOwnerId)) return;
    showData(buildingOwnerId);
  }, [buildingOwnerId]);

  const setModal = useContext(ModalContext);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <BuildingOwnerModal type="NEW" />,
      title: 'Add Building Owner',
      modalSize: 'modal-lg',
      modalContentSize: 'custom-size'
    });
  };

  return (
    <>
      <div className="row mb-3">
        <div className="ml-auto">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-owner font-weight-bold"
          >
            <i className="fas fa-plus" /> Add Building Owner
          </button>
        </div>
      </div>
      <div className="ml-3 card right-section">
        <div className="p-3">
          <div className="d-flex mb-3">
            <div className="col-8 mt-2">
              <span className="font-weight-bold"> Information </span>
            </div>
            <div className="col-4 d-flex">
              <div className="ml-auto">
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleEdit(dataInfo)}
                >
                  <i className="far fa-edit icon-edit" />
                </button>
                <button
                  type="button"
                  className="btn-blank"
                  onClick={handleRemove(dataInfo)}
                >
                  <i className="far fa-trash-alt icon-delete" />
                </button>
              </div>
            </div>
          </div>
          <hr />
          {!_.isEmpty(dataInfo) ? (
            <React.Fragment>
              <div className="row px-3 mt-3">
                <div className="col-12">
                  <table className="transaction-table table table-borderless table-sm table-striped">
                    <tbody>
                      <TransactionRow
                        title="Name"
                        value={_.get(dataInfo, 'attributes.full_name') || '--'}
                      />
                      <TransactionRow
                        title="Status"
                        value={_.get(dataInfo, 'attributes.status') || '--'}
                      />
                      <TransactionRow
                        title="Address"
                        value={_.get(dataInfo, 'attributes.full_address') || '--'}
                      />
                      <TransactionRow
                        title="Tax Identification Number (TIN)"
                        value={_.get(dataInfo, 'attributes.tin') || '--'}
                      />
                      <TransactionRow
                        title="Telephone No."
                        value={_.get(dataInfo, 'attributes.telephone_no') || '--'}
                      />
                      <TransactionRow
                        title="Mobile No."
                        value={_.get(dataInfo, 'attributes.mobile_number') || '--'}
                      />
                      <TransactionRow
                        title="Email Address"
                        value={_.get(dataInfo, 'attributes.email') || '--'}
                      />
                    </tbody>
                  </table>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

BuildingOwnersContent.propTypes = {
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  buildingOwnerId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo: _.get(api, `${c.SHOW_DATA}.item`) || {},
  buildingOwnerId: _.get(match, 'params.buildingOwnerId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuildingOwnersContent);
